<template>
  <BaseDialogForm
    v-model="showCustomerForm"
    :title="
      editMode
        ? `Edit ${customerModule.customer}`
        : `Add ${customerModule.customer}`
    "
    :nonFieldErrors="formErrors.non_field_errors"
    :persistent="true"
    :maxWidth="800"
  >
    <template #content>
      <v-form
        v-model="isValid"
        ref="customerForm"
        :key="formCount"
        @submit.prevent="submitForm"
      >
        <v-row class="ma-0">
          <v-col cols="12">
            <InputField
              id="name"
              v-model="customerDetails.name"
              :label="`${customerModule.customer} Name`"
              name="name"
              :required="true"
              :error-messages="formErrors.name"
              @input="delete formErrors.name"
            />
          </v-col>
          <v-col cols="12" lg="6">
            <InputField
              id="code"
              v-model="customerDetails.code"
              :label="`${customerModule.customer} Code`"
              :required="true"
              name="code"
              :error-messages="formErrors.code"
              @input="delete formErrors.code"
            />
          </v-col>
          <v-col cols="12" lg="6">
            <SelectField
              id="branch"
              v-if="showCustomerForm"
              type="number"
              v-model="customerDetails.branch"
              :items-list="branchList"
              name="branch"
              item-text="name"
              item-value="id"
              :label="`${configurationModule.branch}*`"
              :rules="[
                (val) => !!val || `${configurationModule.branch} is required`,
              ]"
              :error-messages="formErrors.branch"
              @input="delete formErrors.branch"
            />
          </v-col>
          <v-col cols="12" lg="12" class="d-flex align-center">
            <SwitchField
              id="whatsapp_notification"
              v-model="customerDetails.whatsapp_notification"
              inset
              name="whatsapp_notification"
              hide-details
              label="WhatsApp Notification"
              :error-messages="formErrors.whatsapp_notification"
              @input="delete formErrors.whatsapp_notification"
            ></SwitchField>
          </v-col>
          <v-col cols="12" lg="12">
            <InputField
              id="contact_number"
              type="number"
              v-model="customerDetails.contact_number"
              :label="
                customerDetails.whatsapp_notification
                  ? 'Contact Number*'
                  : 'Contact Number'
              "
              name="contact_number"
              :rules="
                customerDetails.whatsapp_notification
                  ? [
                      (val) => !!val || 'Contact Number is required',
                      (val) =>
                        !val ||
                        (val.length >= 9 && val.length <= 12) ||
                        'Contact number should be between 9 to 12 digits!',
                    ]
                  : [
                      (val) =>
                        !val ||
                        (val.length >= 9 && val.length <= 12) ||
                        'Contact number should be between 9 to 12 digits!',
                    ]
              "
              :error-messages="formErrors.contact_number"
              @input="delete formErrors.contact_number"
            />
          </v-col>
          <v-col cols="12" lg="12" class="d-flex align-center">
            <SwitchField
              id="email_notification"
              v-model="customerDetails.email_notification"
              inset
              name="email_notification"
              hide-details
              :required="true"
              label="E-mail Notification"
              :error-messages="formErrors.email_notification"
              @input="delete formErrors.email_notification"
            ></SwitchField>
          </v-col>
          <v-col cols="12" lg="12">
            <InputField
              id="contact_email"
              v-model="customerDetails.contact_email"
              :label="
                customerDetails.email_notification
                  ? 'Contact e-mail*'
                  : 'Contact e-mail'
              "
              name="contact_email"
              :rules="
                customerDetails.email_notification
                  ? [
                      (val) => !!val || 'Contact e-mail is required',
                      (v) => !v || emailValidation(v) || 'Invalid email id',
                    ]
                  : [(v) => !v || emailValidation(v) || 'Invalid email id']
              "
              :error-messages="formErrors.contact_email"
              @input="delete formErrors.contact_email"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template #actions>
      <SecondaryButton
        id="customerReset"
        v-if="!editMode"
        @click="resetForm()"
        btnClass="mr-2 text-uppercase rounded-lg"
        name="Reset"
      >
      </SecondaryButton>
      <PrimaryButton
        id="customerSubmit"
        @click="submitForm()"
        :disabled="!isValid"
        btnClass="text-uppercase rounded-lg"
        name="submit"
      >
      </PrimaryButton>
    </template>
  </BaseDialogForm>
</template>

<script>
import { bus } from "@/main.js";
import {
  emailValidation,
  customerCodeValidation,
  customerNameValidation,
} from "@/utils/functions.js";
import BaseDialogForm from "@/components/LayoutComponents/BaseDialogForm.vue";
import { configurationModule, customerModule } from "@/utils/moduleMapping";

export default {
  components: { BaseDialogForm },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      required: true,
    },
    customerID: {
      type: Number,
    },
  },
  data() {
    return {
      customerNameValidation,
      customerCodeValidation,
      emailValidation,
      customerModule,
      configurationModule,
      fileInput: null,
      formCount: 0,
      isValid: true,
      customerDetails: {
        email_notification: false,
        whatsapp_notification: false,
      },
      formErrors: {},
      branchList: [],
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.getBranchSelectList();
        if (this.editMode && this.customerID) {
          this.getCustomerObject(this.customerID);
        }
      } else {
        this.resetForm();
        this.formErrors = {};
      }
    },
  },
  computed: {
    showCustomerForm: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    resetForm() {
      this.customerDetails = {
        email_notification: false,
        whatsapp_notification: false,
      };
      this.$refs.customerForm.resetValidation();
    },
    getCustomerObject(id) {
      this.$api.customer
        .getCustomerObject(id)
        .then((res) => {
          if (res?.data?.logo) {
            delete res?.data?.logo;
          }
          this.customerDetails = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getBranchSelectList() {
      bus.$emit("showLoader", true);
      this.$api.branch
        .getBranchSelectList({
          limit: "all",
        })
        .then((res) => {
          this.branchList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    submitForm() {
      if (!this.$refs.customerForm.validate()) {
        bus.$emit("showToastMessage", {
          message: "Please correct all the errors to submit the form!",
          color: "error",
        });
        return;
      }
      if (this.editMode) {
        this.customerDetails.is_logo_updated = this.customerDetails?.logo
          ? true
          : false;
        if (!this.customerDetails.logo) {
          delete this.customerDetails.logo;
        }
        this.$api.customer
          .updateCustomerObject({
            id: this.customerDetails.id,
            data: this.customerDetails,
          })
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Customer information updated!",
              color: "success",
            });
            this.$emit("refreshList");
            this.showCustomerForm = false;
          })
          .catch((err) => {
            console.log(err);
            this.formErrors = err.data;
          });
      } else {
        this.$api.customer
          .createCustomerObject(this.customerDetails)
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Customer created!",
              color: "success",
            });
            this.showCustomerForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.formErrors = err.data;
          });
      }
    },
  },
};
</script>

<style>
.v-select__slot label {
  z-index: 2;
}
</style>
